module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmhT"
  }, [_vm._v("NOTE")]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("The title of this book was "), _c('br'), _vm._v("suggested by Herbert Mitgang, "), _c('br'), _vm._v("who experienced World War Two "), _c('br'), _vm._v("as an army correspondent. It is a phrase "), _c('br'), _vm._v("that has been frequently voiced by "), _c('br'), _vm._v("men of his and my generation, "), _c('br'), _vm._v("to distinguish that war from other "), _c('br'), _vm._v("wars, declared and undeclared. "), _c('br'), _vm._v("Quotation marks have been added, "), _c('br'), _vm._v("not as a matter of caprice or "), _c('br'), _vm._v("editorial comment, but simply "), _c('br'), _vm._v("because the adjective “good” mated "), _c('br'), _vm._v("to the noun “war” is so "), _c('br'), _vm._v("incongruous.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74dcbd0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stud_9781595587596_oeb_fm1_r1.vue
// module id = 69
// module chunks = 0